<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-page-header @back="goBack" content="订单详情"></el-page-header>
    </el-breadcrumb>

    <el-card class="box-card" style="margin-top:20px">
      <!-- 打印区域 -->
      <div id="printContent" class="order-container">
        <!-- 打印按钮 -->
        <el-button size="small" type="primary" v-print="printObj">打印订单</el-button>
        <!-- 订单头部增加LOGO -->
        <div class="order-header">
          <div style="display: flex;flex-direction: column;justify-content: space-between;">
           <div class="company-logo">
             <img  src="@/assets/logo.png" alt="公司LOGO">
            <div class="company-info">
              <h2>{{ companyName }}</h2>
            </div>
            </div>
<!--            <div><label style="color: #666">客户要求发货时间：</label><span>2024-03-30 00:00:00-23:59:59{{addForm.best_time}}</span></div>-->
            <div><label style="color: #666">收货单位/客户名称/客户电话：</label><span>{{addForm.inv_payee}}&nbsp;&nbsp;&nbsp;&nbsp;{{addForm.consignee}}&nbsp;&nbsp;&nbsp;&nbsp;{{addForm.tel}}</span></div>
            <div><label style="color: #666">配送商单位/联系电话：</label><span>{{addForm.shipping_name}}&nbsp;&nbsp;&nbsp;{{addForm.shipping_tel}}</span></div>
            <div><label style="color: #666">收货地址：</label><span>{{addForm.province}}&nbsp;&nbsp;{{addForm.city}}&nbsp;&nbsp;{{addForm.district}}&nbsp;&nbsp;{{addForm.address}}</span></div>
          </div>
          <div class="qrcode-box">
            <img :src="qrcodeUrl" alt="二维码" class="qrcode" />
            <p class="qrcode-tip">订单号： {{ addForm.order_sn }}</p>
          </div>
        </div>
        <!-- 商品表格 -->
        <el-table
          :data="goodsList"
          class="goods-table"
          border
          style="width: 100%">
          <el-table-column  label="序号" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="商品名称" width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="品类" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.category?scope.row.category.name:''}}蔬菜水果类</span>
            </template>
          </el-table-column>
          <el-table-column  label="单位" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.unit_name}}斤</span>
            </template>
          </el-table-column>
          <el-table-column  label="规格" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.sku_name}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="数量" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.goods_number}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="单价" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.formated_shop_price}}</span>
            </template>
          </el-table-column>
          <el-table-column  label="金额">
            <template slot-scope="scope">
              <span>{{ scope.row.formated_shop_price*scope.row.goods_number}}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 合计信息 -->
        <div class="total-section">
          <p>合计金额: ¥{{ addForm.order_amount }}</p>
          <h3>应付总额: ¥{{ addForm.order_amount }}</h3>
        </div>

        <!-- 备注 -->
<!--        <div class="remarks">-->
<!--          <h4>备注：</h4>-->
<!--          <p>{{ orderData.remarks }}</p>-->
<!--        </div>-->
      </div>
    </el-card>
  </div>
</template>
<script>
  // 引入二维码组件
  import QRCode from 'qrcode';
  import axios from 'axios'
  import moment from 'moment'     //日期时间转换
  export default {
    components: {  },
    data() {
      return {
        qrcodeUrl: '', // 存储二维码图片的URL
        companyName:sessionStorage.getItem('user_name'),
        // 二维码内容生成
        qrcodeContent:'',
      //  qrcodeContent: this.generateQrcodeContent(),
        printObj: {
          id: "printContent",
          popTitle: '订单信息',
          extraCss: 'https://www.example.com/print.css',
        },
        orderData: {
          orderNo: 'DD20231101001',
          orderDate: '2023-11-01',
          customer: {
            name: '张三',
            phone: '13800138000'
          },
          shipping: {
            address: '北京市朝阳区',
            method: '快递'
          },
          items: [
            { name: '商品A', price: 100, quantity: 2, total: 200 },
            { name: '商品B', price: 50, quantity: 3, total: 150 }
          ],
          totalAmount: 350,
          discount: 50,
          finalAmount: 300,
          remarks: '请尽快发货'
        },

        active:1,
        shipping_order_list:[],

        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],
        goodsList:[],

        employeeList:[],

        baseUrl:'/api/',
        fileList:[],
        shopList:[],
        dicList:[],
        cateList:[],
        provinceList:[],
        info:{},
        addForm:{
          order_amount:0,
          order_sn:'',
          inv_payee:'',
          consignee:'',
          tel:'',
          best_time:'',
          province:'',
          city:'',
          district:'',
          shipping_tel:'',
          shipping_time:'',
          shipping_status:'',
          invoice_no:'',//运单号
          shipping_name:'',//快递公司名称，
          shipping_id:'',
          id:'',
          type_names:'',
          handed_other_name:'',
          handed_id:'',
          address:'',
          total_amount:'',
          payee_account:'',
          payee_name:'',
          credit_code:'',
          employee_id:'',
          type_id:'',
          cate_id:'',
          province_id:"",
          dic_id:'',
          amount:'',
          remark:'',
          order_time:'',
          summary:"",
          manager_name:'',
          unit_name:"",
          title:'',
          shop_id:sessionStorage.getItem('shop_id'),
          access_token:sessionStorage.getItem('token'),
          fileList:[],
          company_id:sessionStorage.getItem('company_id'),
        },
        ruleForm:{
          url:'',
          start_time:"",
          ad_id:'',
          ad_name:'',
          ad_link:'',
          position_id:'',
          ad_code:''
        },
        cateMenus:[],
        editor: null,
        html: '<p>hello</p>',
        toolbarConfig: { },
        editorConfig: { placeholder: '请输入内容...',
          // 所有的菜单配置，都要在 MENU_CONF 属性下
          MENU_CONF: {
            //配置上传图片
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default', // or 'simple'
        rules: {
          title:[
            { required: true, message: "请输入合同名称", trigger: 'change' }
          ],
          position_id:[
            { required: true, message: "请选择分类", trigger: 'change' }
          ],

        },
      }
    },
    mounted(){

      var id= this.$route.query.id;
      if(!isNaN(id)&&id>0){
        this.addForm.id=id;
        this.getOne();
      }

    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      generateQRCode() {
        const content = this.generateQrcodeContent();
        QRCode.toDataURL(content, { width: 120, margin: 1 }, (err, url) => {

          if (err) {
            console.error('二维码生成失败：', err);
          } else {
            this.qrcodeUrl = url;
          }
        });
      },
      generateQrcodeContent() {
        const baseUrl = "http://www.lyhhgyl.cn/#/pages/order/trace"; // 基础URL
        const orderNo = this.addForm.order_sn; // 订单号
        const verifyCode = this.generateVerifyCode(); // 验证码
        return `${baseUrl}?order_sn=${orderNo}&vCode=${verifyCode}`; // 完整链接
      },
      generateVerifyCode() {
        return Math.random().toString().slice(2, 8); // 生成6位随机验证码
      },
      checkActive(){
        let _this=this;
        if(_this.info.finish_time){
          _this.active=5;
        }else if(_this.info.shipping_end_time){
          _this.active=4;
        }else if(_this.info.shipping_time){
          _this.active=3;
        }else if(_this.info.pay_time){
          _this.active=2;
        }else {
          _this.active=1;
        }

      },
      handleCheckAllChange(val) {
        this.$refs.multipleTable.clearSelection();
        if (val) {
          this.goodsList.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        }
        this.isIndeterminate = false;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.goodsList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },

      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      getTypeList(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          ids:_this.info.type_ids
        };
        this.$axios.dicListByIds(param).then((res)=>{
          if(res.code==200){
            res.data.forEach(function(item){
              _this.addForm.type_names +=item.name+',';

            })
          }
          console.log(res);
        });
      },
      goBack() {
        this.$router.go(-1);
      },
      getfile(item){
        return item.url.split('/').pop();
      },

      getDicList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceType",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.dicList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getCateList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:"InvoiceCate",
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            this.cateList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getEmployeeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.employeeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getProvinceList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          parent_id:1,
        }
        this.$axios.regionList(param).then(res=>{
          if(res.code == 200){
            this.provinceList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),

        }
        this.$axios.shopList(param).then(res=>{
          if(res.code == 200){
            this.shopList =res.data;
            this.addForm.shop_id=res.data[0].id;
            this.DataList();
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      submitForm(){
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params=this.addForm;
            console.log('params------',params)

            this.$axios.constructionContractSave(params).then(res=>{
              if(res.code == 200){
                this.$message.success("保存成功");
                this.$router.push('/supervisionContractList')
              }
            }).catch(error=>{
              this.$message.error("保存错误");
              console.log(error);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          order_id:_this.addForm.id
        };
        this.$axios.shippingOrderOne(param).then((res)=>{
          if(res.code==200){
            _this.info=res.data;
            _this.goodsList=_this.info.goods_list;

            this.addForm.order_amount= this.info.order_amount;
            this.addForm.province= this.info.province;
            this.addForm.city= this.info.city;
            this.addForm.district= this.info.district;
            this.addForm.order_sn= this.info.order_sn;
            this.addForm.tel= this.info.tel;
            this.addForm.inv_payee= this.info.user?this.info.user.name:'';
            this.addForm.shipping_tel= this.info.shipping_tel?this.info.shipping_tel:'';
            this.addForm.consignee= this.info.consignee;
            this.addForm.best_time= this.info.best_time;
            this.addForm.address= this.info.address;
            this.addForm.invoice_no= this.info.invoice_no;
            this.addForm.shipping_name= this.info.shipping_name;
            this.addForm.shipping_id= this.info.shipping_id;
            this.addForm.shipping_tel= this.info.shipping_tel;
            this.addForm.shipping_time= this.info.shipping_time?this.dateFormat( this.info.shipping_time):'';

            _this.checkActive();

            this.generateQRCode(); // 初始化二维码内容

           // // _this.getTypeList();
           //  if(res.data.file_urls){
           //    var i=0;
           //    res.data.file_urls.split(',').forEach(function(el) {
           //      var img={
           //        name:res.data.title+i,
           //        url:el
           //      }
           //      console.log('file-----------',img)
           //      _this.addForm.fileList.push(img);
           //      i=i+1;
           //    });
           //
           //  }
          }
          console.log(res);
        });
      },
      getShippingOrderList(){
        let _this=this;
        let param={
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          order_id:_this.addForm.id,
          shop_id:_this.addForm.shop_id
        };
        this.$axios.shippingOrderList(param).then((res)=>{
          if(res.code==200){
            this.shipping_order_list=res.data;
          }
          console.log(res);
        });
      },
      uploadFile (item) {
        let _this=this;
        let file = item.raw;
        this.logoFile=item.raw;
        // formData.append('file', file);
        let param={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id')
        };
        this.$axios.getAliJson(param).then(res=>{
          let data = res['data'];
          console.log('aliyun',data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key + 'mrh/' + autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('aliyun5555',request);

          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;

            _this.ruleForm.ad_code=fullurl;
            var img={
              name:_this.ruleForm.ad_name,
              url:_this.ruleForm.fullurl
            }
            _this.fileList.push(img);
          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )
        });

      },
      resetForm(formName){
        this.$refs[formName].resetFields();
      },
      handleBeforeUpload() {
        console.log('aaaaa');
      },
      uploadSuccess(){

      },
      handleIsopenSelect(){

      },

      getCateMenus(){
        let _this = this;
        let url= '/api/api/mall.Ad_read_lz/getAdPositionMenus';
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        axios.post(url,params).then((res)=>{
          if(res.data.code == 200) {
            _this.cateMenus=res.data.data;
          }
        });
        _this.submit=false;
      },
      uploadImg(file, insertFn){

        let _this=this;
        let param={
          access_token: sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        // console.log(file);
        this.$axios.getAliJson(param).then(res=>{
          console.log('ali_json------',res)

          let data=res['data'];
          console.log(data);
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let  host = data['host'];

          // let fParam=
          //  {
          //    name:file.name,
          //    key:key +'mrh/'+ autoname + suffix,
          //    policy:data['policy'],
          //    OSSAccessKeyId:data['accessid'],
          //    success_action_status:'200',
          //    callback:data['callback'],
          //    Signature:data['signature'],
          //    file:file
          //  };
          //
          //  qs.stringify(fParam)
          //{headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'}}

          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
          request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
          request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
          request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
          request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
          request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
          request.append('file', file);//需要上传的文件 file
          console.log('file=------',file)
          axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
            //请求成功，触发then中的函数
            console.log('upload -res--------',res)
            var fileurl = res.data.filename; //上传完成后的文件oss地址
            var fullurl=host+'/'+fileurl;
            setTimeout(function(){
              insertFn(fullurl); //插入地址
            },2000);


          })
            .catch(error =>
              //请求失败，触发catch中的函数 可省略
              console.log(error)
            )

        });

        // let imgData = new FormData();
        // imgData.append('file', file);
        // console.log('lu-----------',file)
        // //调用上传图片接口，上传图片  我这里testUpImg是测试接口
        // testUpImg(imgData).then(response => {
        //   if(response.data.code == 0){
        //     //插入后端返回的url
        //     insertFn(response.data.data.url);
        //   }else{
        //   }
        // })
      },
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second;
      },
      urlParse(_url = '') {
        let url_obj = new URL(_url || window.location.href);
        let search_path = url_obj.search;
        let handle_path = decodeURIComponent(search_path.substr(1));

        let handle_path_arr = handle_path.split('&');
        let search_params = {};
        for(let item of handle_path_arr) {
          let r = item.split('=');
          search_params[r[0]] = r[1];
        }
        return {
          protpcol: url_obj.protocol,
          search: url_obj.search,
          host: url_obj.host,
          port: url_obj.port,
          pathname: url_obj.pathname,
          searchParams: search_params
        }
      },

    },

    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    },
    computed: {
      finalAmount() {
        return this.orderData.totalAmount - this.orderData.discount;
      }
    },

  };
</script>
<style scoped>
  /* 新增LOGO样式 */
  .company-logo {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }

  .company-logo img {
    height: 30px;
    margin-right: 20px;
  }

  .company-info h2 {
    margin: 0;
    font-size: 24px;
  }

  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 2px solid #eee;
  }

  .qrcode {
    display: block;
    margin: 0 auto;
    background: white; /* 二维码背景色 */
    padding: 10px; /* 内边距 */
  }
  /* 二维码样式 */
  .qrcode-box {
    text-align: center;
    padding: 5px;
  }

  .qrcode-tip {
    font-size: 12px;
    color: #666;
    margin: 5px 0 0;
  }

  /* 打印样式调整 */
  @media print {
    .company-logo img {
      height: 50px !important;
      filter: grayscale(100%); /* 保证打印黑白分明 */
    }

    .qrcode-box {
      border: 1px solid #000 !important;
      background: white !important;
    }

    .qrcode {
      padding: 5px;
      background: white !important;
    }
  }
  /* 在需要分页的位置添加 */
  .page-break {
    page-break-before: always;
  }

  /* 屏幕显示样式 */
  .order-container {
    padding: 10px;

    margin: 0 auto;
  }

  .goods-table {
    margin: 20px 0;
  }

  .total-section {
    text-align: right;
    margin-top: 20px;
  }


  /* 打印专用样式 */
  @media print {
    body * {
      visibility: hidden;
    }

    #printContent, #printContent * {
      visibility: visible;
    }

    .order-container {
      width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .el-table {
      border-collapse: collapse;
    }

    .el-table td, .el-table th {
      border: 1px solid #000 !important;
      padding: 8px;
    }

    .total-section h3 {
      font-size: 18px;
      color: #000;
    }

    /* 隐藏打印按钮 */
    .el-button {
      display: none;
    }
  }
</style>
